// src/publish/serialize/csv.js — the carousel's slides as CSV, one row per slide.
//
// Canva's bulk create takes one slide per row. Columns, in this order, with
// their header words read from i18n at call time (outputs:pieces.csv.<column>,
// the operator's UI language for a file she opens in Excel — Italian:
// numero;tipo;titolo;testo;indicazione_visiva):
//   number;type;title;text;visualCue
// ";" as the separator (Excel in an Italian locale), CRLF line ends, a BOM so
// Excel reads UTF-8, and every field quoted when it holds ";", a quote or a
// newline. A field that opens with "=", "+", "-" or "@" is prefixed with a
// single quote before quoting: Excel and Sheets would otherwise evaluate it as
// a formula (=HYPERLINK(…) in a slide text would run on open). Slides are
// collected from the slide blocks of the piece list, in order; a list with no
// slide block gives the header line only.

import i18n from '../../i18n/index.js';
import { asBlocks } from '../blocks.js';
import { runsToPlain, blocksToPlain } from './plain.js';

export const CSV_SEPARATOR = ';';
export const CSV_COLUMNS = ['number', 'type', 'title', 'text', 'visualCue'];

/** The header words in the current UI language. */
export const csvHeaders = () => CSV_COLUMNS.map((c) => i18n.t(`outputs:pieces.csv.${c}`));

const FORMULA_LEAD_RE = /^[=+\-@]/;

function csvField(value) {
  const raw = String(value ?? '');
  const s = FORMULA_LEAD_RE.test(raw) ? `'${raw}` : raw;
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Every slide block of every piece, in document order. */
export function slidesOf(pieces) {
  const out = [];
  for (const p of Array.isArray(pieces) ? pieces : []) {
    for (const b of asBlocks(p?.blocks)) if (b.type === 'slide') out.push(b);
  }
  return out;
}

/** The CSV text (BOM + header + one row per slide). */
export function slidesToCsv(pieces) {
  const rows = [csvHeaders()];
  for (const s of slidesOf(pieces)) {
    rows.push([
      s.number,
      s.slideType || '',
      runsToPlain(s.headline),
      blocksToPlain(s.body),
      s.visualCue || '',
    ]);
  }
  return `﻿${rows.map((r) => r.map(csvField).join(CSV_SEPARATOR)).join('\r\n')}\r\n`;
}
